import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Font,
  Image as PDFImage
} from '@react-pdf/renderer';

Font.register({
  family: 'Roboto',
  fonts: [{ src: '/Roboto-Bold.ttf', fontWeight: 'medium' }]
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const styles = StyleSheet.create({
  page: {
    padding: 10,
    // paddingTop: '5%',
    justifyContent: 'flex-start',
    alignItems: 'center',
    border: '3px solid black'
  },
  text: {
    fontSize: 10
  },
  textUnderlined: {
    fontSize: 10,
    textDecoration: 'underline',
    textDecorationColor: 'black',
    textDecorationThickness: 1.5,
    width: '120%'
  },
  heading: {
    fontSize: 14,
    fontWeight: 'bold',
    textAlign: 'center'
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '200%',
    gap: 5,
    paddingBottom: '3px',
    borderBottom: '1px solid black',
    paddingTop: '130px',
    paddingRight: '40px',
    paddingLeft: '40px',
    position: 'relative'
  },
  contentContainer3: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    borderTop: '1px solid black'
  },
  column: {
    width: '50%',
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    marginLeft: '7%'
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 2,
    width: '100%'
  },
  label: {
    fontWeight: 'bold',
    fontSize: 10
  },
  value: {
    fontSize: 10,
    fontWeight: 'normal',
    width: '65%'
  },
  leftColumn: {
    width: '50%',
    display: 'flex',
    flexDirection: 'column',
    gap: 0
  },
  rightColumn: {
    width: '50%',
    display: 'flex',
    flexDirection: 'column',
    gap: 5
  },
  sectionHeading: {
    fontWeight: 'bold',
    fontSize: 11,
    marginBottom: 5,
    fontFamily: 'Roboto'
  },
  sectionContent: {
    fontSize: 10,
    marginBottom: 10,
    fontFamily: 'Roboto'
  }
});

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const PatientRegistrationPdf8 = ({ data }) => {
  function formatDate(dateString) {
    const date = new Date(dateString);
    const istParts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Asia/Kolkata',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    }).formatToParts(date);
    const day = istParts.find((p) => p.type === 'day').value;
    const month = istParts.find((p) => p.type === 'month').value;
    const year = istParts.find((p) => p.type === 'year').value;
    return `${day}/${month}/${year}`;
  }

  const ageString = data.age;
  const years = ageString.match(/\d+Y/);

  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title={`${data.name} Registration`} style={{ border: '3px solid black' }}>
          <Page size="A4" style={styles.page}>
            <View
              style={{
                top: '70%',
                position: 'absolute',
                bottom: '0%',
                left: '50%',
                width: '1.5px',
                height: '15%',
                backgroundColor: '#000',
                transform: [{ translateX: '-50%' }]
              }}
            />
          </Page>
          <View style={styles.contentContainer}>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text
                  content="UHID NO.             :-            "
                  style={{ ...styles.label, fontFamily: 'Roboto' }}
                />
                <Text
                  content={data.uhid}
                  style={{
                    ...styles.value,
                    textAlign: 'start',
                    paddingBottom: '2px'
                  }}
                />
              </View>
              <View style={styles.row}>
                <Text content="Patient Name     :-            " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                <Text
                  content={data.name}
                  style={{
                    ...styles.value,
                    textAlign: 'start',
                    paddingBottom: '2px'
                  }}
                />
              </View>
              <View style={styles.row}>
                <Text content="Consultant          :-            " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                <Text
                  content={data.consultant}
                  style={{
                    ...styles.value,
                    textAlign: 'start',
                    paddingBottom: '2px'
                  }}
                />
              </View>
              <View style={styles.row}>
                <Text content="OP Date               :-          " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                <Text
                  content={`${formatDate(data?.reg_date)} ${data?.reg_time}`}
                  style={{ ...styles.value, textAlign: 'start' }}
                />
              </View>
            </View>

            <View style={styles.column}>
              <View style={styles.row}>
                <Text
                  content="OP No.           :-      "
                  style={{ ...styles.label, fontFamily: 'Roboto', position: 'relative', left: '7%' }}
                />
                <Text
                  content={`${data.op_no}`}
                  style={{
                    ...styles.value,
                    textAlign: 'start',
                    paddingBottom: '2px'
                  }}
                />
              </View>
              <View style={{ ...styles.row }}>
                <Text
                  content="Age/Sex        :-      "
                  style={{ ...styles.label, fontFamily: 'Roboto', position: 'relative', left: '7%' }}
                />
                <Text
                  content={`${data.age} / ${data.gender}`}
                  style={{ ...styles.value, textAlign: 'start', paddingBottom: '2px' }}
                />
              </View>
              <View style={{ ...styles.row }}>
                <Text
                  content="Mobile No     :-     "
                  style={{ ...styles.label, fontFamily: 'Roboto', position: 'relative', left: '7%' }}
                />
                <Text
                  content={`${data.mobile}`}
                  style={{ ...styles.value, textAlign: 'start', paddingBottom: '2px' }}
                />
              </View>

              <View style={{ ...styles.row }}>
                <Text
                  content="Address        :-      "
                  style={{ ...styles.label, fontFamily: 'Roboto', position: 'relative', left: '7%' }}
                />
                <Text content={`${data.address}`} style={{ ...styles.value, textAlign: 'start' }} />
              </View>
            </View>
          </View>
          <View style={{ ...styles.contentContainer, paddingTop: '25%' }}>
            {/* Left Column - Medical Data */}
            <View style={styles.leftColumn}>
              <Text content="Chief Complaints & Present Illness:" style={styles.sectionHeading} />

              <Text content="Present Illness:" style={{ ...styles.sectionHeading, marginTop: '6%' }} />

              <Text content="Past History:" style={{ ...styles.sectionHeading, marginTop: '6%' }} />

              <Text content="Allergies:" style={{ ...styles.sectionHeading, marginTop: '6%' }} />

              <Text content="Physician Examination" style={{ ...styles.sectionHeading, marginTop: '6%' }} />

              <Text content="Temp: ____________________" style={{ ...styles.sectionContent, marginTop: '6%' }} />
              <Text content="Pulse: ____________________" style={{ ...styles.sectionContent }} />
              <Text content="Bp: ____________________" style={{ ...styles.sectionContent }} />
              <Text content="R/R: ____________________" style={{ ...styles.sectionContent }} />
              <Text content="Spo2: ____________________" style={{ ...styles.sectionContent }} />

              <Text content="Pain Score:" style={{ ...styles.sectionHeading, marginTop: '6%' }} />

              <Text content="Provisional Diagnosis:" style={{ ...styles.sectionHeading, marginTop: '6%' }} />

              <View style={{ flexDirection: 'row', alignItems: 'center', marginTop: '4%' }}>
                <Text content="Investigation:" style={styles.sectionHeading} />
              </View>

              <View style={{ flexDirection: 'row', alignItems: 'center', marginTop: '40%' }}>
                <Text content="Screeening of Nutritional Needs :" style={styles.sectionHeading} />
              </View>
              <View style={{ flexDirection: 'row', alignItems: 'center', marginTop: '5%' }}>
                <Text content="Follow Up :" style={styles.sectionHeading} />
              </View>
            </View>

            {/* Right Column - Image */}
            <View style={styles.rightColumn}>
              <PDFImage
                src="/emojis.jpg"
                style={{ width: '60%', marginLeft: '40%', height: '50px', marginBottom: 1 }}
              />
              <View
                style={{
                  flexDirection: 'row',
                  alignItems: 'center',
                  marginTop: '150%',
                  width: '100%',
                  position: 'relative',
                  top: 150,
                  right: 10,
                  justifyContent: 'flex-end'
                }}
              >
                <Text
                  content="Signature Of Doctor"
                  style={{
                    ...styles.sectionHeading,
                    borderTop: '1px solid black',
                    alignSelf: 'flex-end'
                  }}
                />
              </View>
            </View>
          </View>
        </Document>
      </PDFViewer>
    </div>
  );
};
